// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Button, Grid, Segment, Loader, Container, Card } from 'semantic-ui-react'
import sheetweb from '../assets/ipadweb.png'
import CTA from './CTA'
import Img from 'react-image'

const ImageLoader = (
  <center style={{ padding: '10%' }}>
    <Loader size='large' active inline />
  </center>
)

export default class WebSheet extends Component {
  render () {
    return (
      <Container className='mtb centerX'>
        <div className='center'>
          <h1 style={{ fontWeight: 900 }}>WebSheet</h1>
          <h3>Convert Google Sheet to Web App For FREE</h3>
          <p>Share with others using a link</p>
        </div>
        <Segment basic padded>
          <Grid stackable verticalAlign='middle' reversed='mobile'>
            <Grid.Column width='8' textAlign='center'>
                <center className='lightshadow'>
                  <Segment fluid style={{ borderRadius: 0, padding: '3vh' }}>
                    <Card.Group centered>
                      <Card compact>
                        <Button
                          basic
                          size='large'
                          color='black'
                          href='https://murkstom.com/public/sheet/1n5IbATXBP6Xx_dW9J8xMl5aKcOMTi7MJr1TkC2FQ80o'>
                          Demo App
                        </Button>
                      </Card>
                      <Card compact>
                        <Button
                          basic
                          size='large'
                          color='black'
                          href='https://murkstom.com/public/sheet/1FoBL0H5xV3xcE0Je1DG3URda4MWMRc9Fdqr16PfVa-w'>
                          Real Estate Directory
                        </Button>
                      </Card>
                      <Card compact>
                        <Button
                          basic
                          size='large'
                          color='black'
                          href='https://murkstom.com/public/sheet/1jqM7xqFKQ6KdeBSXahQ1LucajmUWevLsxq-k57icff0'>
                          Generic Food Database
                        </Button>
                      </Card>
                      <Card compact>
                        <Button
                          basic
                          size='large'
                          color='black'
                          href='https://murkstom.com/public/sheet/1V27KQFiY9gm89ueFR0lnauzx9M_eLI3CE5wFZffMxTk'>
                          Public Domain Films
                        </Button>
                      </Card>

                      <Card compact>
                        <Button
                          basic
                          size='large'
                          color='black'
                          href='https://murkstom.com/public/sheet/1TYSRLZq_yhRRr-nDo_Zm_3RkR81VYIAPwodtOk8_beI'>
                          NPM Packages Collection
                        </Button>
                      </Card>
                    </Card.Group>
                  </Segment>
                </center>
            </Grid.Column>
            <Grid.Column width='8'>
              <center>
                <Img
                  src={sheetweb}
                  loader={ImageLoader}
                  style={{
                    maxWidth: '80%',
                    resizeMode: 'contain',
                    borderRaduis: 7
                  }}
                  alt='web'
                />
              </center>
            </Grid.Column>
          </Grid>
        </Segment>
        <CTA />
      </Container>
    )
  }
}
